import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import WarningIcon from '@mui/icons-material/Warning';
import CheckIcon from '@mui/icons-material/Check';

interface ContextBarProps {
  topNav: string;
  section: string;
  view: string;
  columnCount: number;
  isDirty: boolean;
}

const ContextBar: React.FC<ContextBarProps> = ({
  topNav,
  section,
  view,
  columnCount,
  isDirty,
}) => {
  return (
    <Box
      sx={{
        height: 32,
        backgroundColor: '#F5F5F5',
        borderBottom: '1px solid #E0E0E0',
        padding: '0 16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 11,
        color: '#666',
      }}
    >
      {/* Left side: breadcrumb path */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          component="span"
          sx={{ fontSize: 11, color: '#00897B', fontWeight: 600 }}
        >
          {topNav}
        </Typography>
        <Typography
          component="span"
          sx={{ fontSize: 11, color: '#CCC', mx: 0.5 }}
        >
          {' / '}
        </Typography>
        <Typography component="span" sx={{ fontSize: 11, color: '#666' }}>
          {section}
        </Typography>
        <Typography
          component="span"
          sx={{ fontSize: 11, color: '#CCC', mx: 0.5 }}
        >
          {' / '}
        </Typography>
        <Typography
          component="span"
          sx={{ fontSize: 11, fontWeight: 500, color: '#333' }}
        >
          {view}
        </Typography>
      </Box>

      {/* Right side: column count + save status */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* Column count */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <ViewColumnIcon sx={{ fontSize: 14, color: '#666' }} />
          <Typography component="span" sx={{ fontSize: 11, color: '#666' }}>
            {columnCount} items
          </Typography>
        </Box>

        {/* Save status */}
        {isDirty ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <WarningIcon sx={{ fontSize: 14, color: '#D32F2F' }} />
            <Typography
              component="span"
              sx={{ fontSize: 11, color: '#D32F2F', fontWeight: 600 }}
            >
              Unsaved changes
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CheckIcon sx={{ fontSize: 14, color: '#4CAF50' }} />
            <Typography
              component="span"
              sx={{ fontSize: 11, color: '#4CAF50', fontWeight: 500 }}
            >
              Saved
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ContextBar;
